import React, { useEffect, useState } from 'react';
import './index.css';
import { isValidUser } from '../Utils/authUtils';
import { Icon, ICONS, Loader, SuccessModal } from '@ohif/ui';
import classnames from 'classnames';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { forgotPasswordValidationSchema, forgotPasswordInitialValues } from './helper/schema';
import { useNavigate } from 'react-router-dom';
import { apiRequest } from '@custom/Utils/config/apiRequest';
import { _authUrls } from '@custom/Utils/constants/apiUrls';
import { ForgotPasswordFormTypes } from './helper/auth';
import { useDispatch, useSelector } from 'react-redux';
import forgotPassword from '../rtk-apis/authentication/forgotPassword';
import { AppDispatch, RootState } from '../store/store';

const ForgotPassword = () => {

    const navigate = useNavigate();
    const [apiErrorMessage, setApiErrorMessage] = useState('');
    const [isSuccessModal, setSuccessModal] = useState(false)
    const [email, setEmail] = useState("")
    const dispatch = useDispatch<AppDispatch>();
    const data = useSelector((state: RootState) => state?.forgotPassword);


    const submitForm = async (values: ForgotPasswordFormTypes) => {
        setEmail(values?.email)
        await dispatch(forgotPassword(values))

        // try {
        //     // const response = await dispatch(forgotPassword(values)).unwrap(); // Extract actual payload
        //     // if(response?.msg == "Email ID is not exists") {
        //     //     setApiErrorMessage('Email ID does not exists.');
        //     //     setTimeout(()=>{
        //     //         setApiErrorMessage("")
        //     //     },1500)
        //     // }
        //     // if (response?.status == "SUCCESS") {
        //     //     navigate('/verification', {
        //     //         state: {
        //     //             email: values.email
        //     //         }
        //     //     });
        //     // }
        // } catch (error) {
        //     setApiErrorMessage("An error occurred. Please check your internet connection and try again.");
        // }
    };

    useEffect(() => {
        if (isValidUser()) {
            navigate('/dashboard');
        }
    }, []);
    useEffect(() => {
        if (data.status === 'SUCCESS') {
            setSuccessModal(true)
            setTimeout(() => {
                navigate('/verification', {
                    state: {
                        email: email
                    }
                });
            }, 500)
        }
        else if(data.status==='ERROR'){
            setApiErrorMessage('Email ID does not exists.');
                 setTimeout(()=>{
                setApiErrorMessage("")
          },500)
        }
    }, [data?.status])
    const closeModal = () => {
        setSuccessModal(false)

    }

    return (
        <>
            <div
                className={classnames("h-screen w-full bg-cover bg-no-repeat bg-center")}
                style={{
                   backgroundImage: "url('/assets/BG.png')",
                   backgroundColor: '#eaf4f2',
                   backgroundSize: 'contain',
                   backgroundRepeat: 'no-repeat',
                   backgroundPosition:'right top',
                   display: 'flex',
                   flexDirection: 'column',
                   justifyContent: 'space-between'
                }}
                >
                <div className="flex justify-between items-start p-4">
                    <img
                    src={ICONS.SevenHillsLogo}
                    alt="Seven Hills Logo"
                    />
                    <div
                    className="flex gap-4"
                    style={{
                        position: 'fixed',
                        bottom: '20px',
                        right: '20px',
                    }}
                    >
                    <img
                        src={ICONS.GDPR}
                        style={{
                        width: '100px',
                        height: 'auto',
                        borderRadius: '12px',
                        backgroundColor: 'rgba(255, 255, 255, 0.1)',
                        padding: '8px',
                        }}
                        alt="GDPR"
                    />
                    <img
                        src={ICONS.Hippa}
                        style={{
                        width: '120px',
                        height: 'auto',
                        borderRadius: '12px',
                        backgroundColor: 'rgba(255, 255, 255, 0.1)',
                        padding: '8px',
                        }}
                        alt="HIPAA"
                    />
                    </div>
                </div>
            <div className={classnames("login-container w-[400px] h-[420px] p-6 bg-white text-black mx-auto rounded-lg transform -translate-x-1/2 -translate-y-1/2 absolute top-1/2 left-1/2 border border-gray-300 shadow-lg")}>
                <div className={classnames("flex flex-col justify-center items-center mb-4")}>
                    <img className='w-12 h-12 mb-2' src={`${ICONS.LockIconQuestionMark}`} alt="Reset Icon" />
                    <h1 className={classnames('text-black font-bold text-xl')}>Forgot your Password</h1>
                </div>
                <Formik
                    initialValues={forgotPasswordInitialValues}
                    validationSchema={forgotPasswordValidationSchema}
                    onSubmit={submitForm}
                >
                    {({
                        values,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        touched
                    }) => (
                        <Form onSubmit={handleSubmit}>
                               <div className={classnames("flex flex-col gap-1 my-4")}>
                                <label htmlFor="email" className="form__label email_text">Email ID</label>
                                <div className="form__Field relative">
                                    <Field
                                        name="email"
                                        id="email"
                                        type="email"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.email}
                                        autoComplete="off"
                                        placeholder="Enter your Email ID"
                                        className={classnames('form__input')}
                                    />
                                </div>
                                <ErrorMessage name="email" component="div" className="form__error" />
                                {apiErrorMessage && (
                                <p className="form__error text-center">
                                    {apiErrorMessage}
                                </p>
                            )}
                            </div>

                                <div className="mt-5 btn__group btn__group--full">
                                    <button type="submit" className="btn btn__primary btn--full">
                                        Continue
                                    </button>
                                </div>
                                {/* {apiErrorMessage && (
                                <p className="text-red-500 font-normal text-sm text-center">
                                    {apiErrorMessage}
                                </p>
                            )} */}
                            </Form>
                        )}
                    </Formik>
                    <div className='flex justify-center items-center p-2 text-[#49475A] mt-2 pb-0'>
                        <Icon name='chevron-left' className="text-gray-600" />
                        <button style={{ fontWeight: '600', color: 'rgb(73 71 90)', cursor: 'pointer' }} onClick={() => navigate('/login')}>
                            Back to Login
                        </button>
                    </div>
                </div>
                <div className="text-center text-sm text-[#000000] mt-4">
                    © 2025 Svensa Solutions LLC, UAE - Svensa Images. <br />
                    All rights reserved.
                </div>
            </div>
            <Loader isLoaderOpen={data.loading}></Loader>
            <SuccessModal isSuccessModalOpen={isSuccessModal} title={data?.msg} handleCloseModal={closeModal} />
        </>
    );
};

export default ForgotPassword;
